import React from 'react';
import ReactGA from 'react-ga4';

import CampaignMenu from './CampaignMenu.jsx';
import CampaignInfoPlay from './CampaignInfoPlay.jsx';
import CampaignDaysPlay from './CampaignDaysPlay.jsx';
import Weekdays from './Weekdays.jsx';
import EnvironmentPlay from './EnvironmentPlay.jsx';
import Regions from './Regions.jsx';
import PanelMap from './PanelMap.jsx';
import BackgroundImage from './BackgroundImage.jsx';
import numberFormatter from '../../utils/numberFormatter.js';
import * as consts from '../../models/consts.js'
import * as colors from '../../services/colors.js'
import moment from 'moment';
import QueryStringService from '../../services/queryStringService.js';
import { toast } from "react-toastify";
import 'react-toastify/dist/ReactToastify.css';
require('moment-weekday-calc');


export default class CampaignPlayOldLayout extends React.Component {
    constructor(props) {
        super(props);
        this.queryStringService = new QueryStringService();
        this.startDatePlay = null;
        this.endDatePlay = null;
        this.startDatePosting = null;
        this.endDatePosting = null;
        this.state = {
            loaded: false,
            postingPeriod: 0
        };

    }

    componentDidMount() {
        const NEW_PROMISES_CUTOFF_DATE = this.props.parameters.clientSettings.newPromisesCutoffDate;
        const orderLines = this.props.orderData.orderLines;
        //in case the user has not selected start and end date with the date pickers the period is selected from the first and last of the selected orderlines
        if (!(this.props.startDate && this.props.endDate)) {
            let playStart, playEnd;
            for (let i = 0; i < orderLines.length; i++) {
                if (this.props.urlOrderLineIds.indexOf(orderLines[i].id) !== -1) {
                    if (orderLines[i].type === 'play') {
                        if (playStart) {
                            if (moment(orderLines[i].periodStart) < moment(playStart)) {
                                playStart = orderLines[i].periodStart;
                            }
                        } else {
                            playStart = orderLines[i].periodStart;
                        }

                        if (playEnd) {
                            if (moment(orderLines[i].periodEnd) > moment(playEnd)) {
                                playEnd = orderLines[i].periodEnd;
                            }
                        } else {
                            playEnd = orderLines[i].periodEnd;
                        }
                    }
                }
            }
            this.startDatePlay = playStart;
            this.endDatePlay = playEnd;
        } else {
            this.startDatePlay = this.props.startDate;
            this.endDatePlay = this.props.endDate;
        }

        const campaignPromise = this.fetchLocalParam5CampaignPromise(typeof this.props.selectedOrderLines[0].localParameter5 === "string" ? this.props.selectedOrderLines[0].localParameter5.toLowerCase() : "");
        const selectedDataType = this.fetchCorrectFollowupDataType(campaignPromise)
        const useOldPlay = this.shouldUseOldPlay(this.queryStringService.getCurrentCountry(), NEW_PROMISES_CUTOFF_DATE, this.props.selectedOrderLines[0], campaignPromise)

        ReactGA.event({
            category: 'User',
            action: 'Report',
            label: 'Play'
        });

        this.props.selectedOrderLines.forEach(orderLine => {
            orderLine.targetVAC = numberFormatter.roundContactsAsInPopAPI(orderLine.targetVAC);
            orderLine.targetPlays = numberFormatter.roundContactsAsInPopAPI(orderLine.targetPlays);
        });
        this.props.orderLinesData.orderLineDataInformation.idsTargetRaw = this.props.orderLinesData.orderLineDataInformation.idsTarget
        this.props.orderLinesData.orderLineDataInformation.idsTarget = numberFormatter.roundContactsAsInPopAPI(this.props.orderLinesData.orderLineDataInformation.idsTarget)
        this.setState({
            loaded: true,
            selectedCampaignPromise: campaignPromise,
            useOldPlay: useOldPlay,
            selectedDataType: selectedDataType,
            selectedCampaignType: "play",
            campaignName: this.props.urlOrderLineIds.length === 1 ? this.props.orderData.orderLines.filter(x => x.id === this.props.urlOrderLineIds[0])[0].name : '',
            periodManuallySelected: this.props.startDate && this.props.endDate,
            periodStartPlay: this.startDatePlay,
            periodEndPlay: this.endDatePlay,
        });
    }

    shouldUseOldPlay(country, cutOffDate, orderline, campaignPromise) {
        let beforeCutOffDate = false;
        switch (country) {
            case consts.Countries.se:
                if (!isNaN(Date.parse(orderline.createdOn))) {
                    beforeCutOffDate = Date.parse(orderline.createdOn) < Date.parse(cutOffDate)
                }
                break;
            case consts.Countries.no:
            case consts.Countries.dk:
                if (!isNaN(Date.parse(orderline.periodStart))) {
                    beforeCutOffDate = Date.parse(orderline.periodStart) < Date.parse(cutOffDate)
                }
                break;
        }
        if (!beforeCutOffDate && campaignPromise != '') {
            return false;
        }
        return true;
    }

    fetchCorrectFollowupDataType(campaignPromise) {
        
        if (['sov', 'sfi', 'sovp'].indexOf(campaignPromise) > -1) 
            return "plays";
        else if (this.props.orderLinesData.playData.contacts.target > 0) 
            return "contacts";

        return "plays";
    }

    fetchLocalParam5CampaignPromise(localParameter5) {
        let selectedCampaignPromise = ''
        switch (localParameter5) {
            case consts.CampaignPromisePackings.sovp:
                selectedCampaignPromise = consts.CampaignPromisePackings.sovp;
                break;
            case consts.CampaignPromisePackings.sov:
                selectedCampaignPromise = consts.CampaignPromisePackings.sov;
                break;
            case consts.CampaignPromisePackings.sovd:
                selectedCampaignPromise = consts.CampaignPromisePackings.sovd;
                break;
            case consts.CampaignPromisePackings.vac:
                selectedCampaignPromise = consts.CampaignPromisePackings.vac;
                break;
            case consts.CampaignPromisePackings.sfi:
                selectedCampaignPromise = consts.CampaignPromisePackings.sfi;
                break;
            case consts.CampaignPromisePackings.fxp:
                selectedCampaignPromise = consts.CampaignPromisePackings.fxp;
                break;
            case consts.CampaignPromisePackings.fxa:
            case consts.CampaignPromisePackings.fxi:
                selectedCampaignPromise = consts.CampaignPromisePackings.flexai;
                break;
        }
        return selectedCampaignPromise;
    }

    handleSelectDataType(dataType) {
        this.setState({
            selectedDataType: dataType
        });
    }

    allowAddressExport(campaignType, slotSubstitutionRule, campaignStartDate) {
        if (campaignType === "play") {
            return true;
        }
        if (slotSubstitutionRule === "1") {
            return true;
        }
        let exportAllowedFrom = moment(campaignStartDate).addWorkdays(this.props.parameters.daysToStartAdressExport * -1);
        return moment() >= exportAllowedFrom;
    }


    render() {

        let selectedData, color1, color2, showTarget, postingData, selectedSummaryData, selectedSummaryDataType, campaignDaysGraph, selectedDetailsData, showCampaignDays;
        let packageType = "";
        let allowAddressExport = true;
        let contactsData;
        let otsCutoffDate = this.props.parameters.clientSettings.noOtsDKCutoffDate;
        let useOts = this.props.parameters.useOTS;

        if (otsCutoffDate) {
            useOts = otsCutoffDate > this.state.periodStartPlay;
        }
        let contactsLabel = useOts ? "Contacts" : "VAC Contacts";
        let selectedDataType = contactsLabel;
        let contactsLabelGraphs = contactsLabel;
        let contactsText = "";
        if (this.state.selectedCampaignType === "play") {
            if (this.props.parameters.useOTS) {
                contactsText = "Contacts is referencing March month data.";
            } else {
                contactsText = "VAC Contacts is referencing March month data.";
            }
        }
        let country = this.queryStringService.getCurrentCountry();

        if (this.props.orderLinesData && this.state.loaded) {

            if (this.state.selectedCampaignType === "play") {
                if (country === "se") {
                    if (this.props.parameters.useOTS) {
                        contactsText = "Contacts is referencing an average week.";
                    } else {
                        contactsText = "VAC Contacts is referencing an average week.";
                    }
                }
                else {
                    if (this.props.parameters.useOTS) {
                        contactsText = "Contacts is referencing March month data.";
                    } else {
                        contactsText = "VAC Contacts is referencing March month data.";
                    }
                }
            }
            if (!this.state.useOldPlay) { contactsText = '' }
            else if (this.state.selectedCampaignPromise == 'flexai' || this.state.selectedCampaignPromise == 'fxp' || this.state.selectedCampaignPromise === 'vac') {
                contactsText = '*VAC contacts calculated based on 5 sec spot length and for an average week. Potentially including screens not yet in IDS with estimated VAC values.'
            }
            if (country == consts.Countries.dk && this.state.selectedCampaignPromise != '') {
                contactsText = <span>Terms & Conditions and Cookie Policy The general terms and conditions document at <a href="https://www.clearchannel.dk/forretnings-og-handelsbetingelser/">https://www.clearchannel.dk/forretnings-og-handelsbetingelser/</a></span>;
            }

            //when there is only one spothlength and it is 10s then display the alternate contacts data in the graphs
            if (this.props.orderLinesData.playData.spotlengths &&
                this.props.orderLinesData.playData.useAlternateContacts &&
                this.props.orderLinesData.playData.spotlengths.length === 1 &&
                this.props.orderLinesData.playData.spotlengths[0] === 10 &&
                country !== "no") {
                contactsData = this.props.orderLinesData.playData.alternateContacts;
                contactsLabelGraphs += ' <br/>(10 sec)';
            }
            else {
                contactsData = this.props.orderLinesData.playData.contacts;
            }
            showCampaignDays = true;
            color1 = colors.playPrimary;
            color2 = colors.playSecondary;
            switch (this.state.selectedDataType) {
                case "plays":
                    selectedData = this.props.orderLinesData.playData.plays;
                    selectedDataType = "Plays";
                    break;
                case "contacts":
                    selectedData = contactsData;
                    selectedDataType = contactsLabelGraphs;
                    break;
                default:
                    console.log("Invalid data type", this.state.selectedDataType);
            }
            {/* Campaign day shall always show Contacts as area and plays as line  */ }
            campaignDaysGraph =
                <CampaignDaysPlay
                    selectedCampaignPromise={this.state.selectedCampaignPromise}
                    color1={color1}
                    color2={color2}
                    areaData={contactsData.campaignDays}
                    lineData={this.props.orderLinesData.playData.plays.campaignDays}
                    areaLabel={contactsLabelGraphs}
                    useOldPlay={this.state.useOldPlay}
                    endDate={this.state.periodEndPlay}
                    byDay={this.props.orderLinesData.playData.byDay} />;
            if (this.props.orderLinesData.playData.contacts.target > 0) {
                selectedSummaryData = this.props.orderLinesData.playData.contacts;
                selectedSummaryDataType = "contacts";
            } else {
                selectedSummaryData = this.props.orderLinesData.playData.plays;
                selectedSummaryDataType = "plays";
            }
            selectedDetailsData = this.props.orderLinesData.playData;
            selectedDetailsData.startDate = this.state.periodStartPlay;
            selectedDetailsData.endDate = this.state.periodEndPlay;
            showTarget = selectedSummaryData.target > 0;
        }

        return (
            <div>

                <BackgroundImage
                    campaignType={this.state.selectedCampaignType}
                    packageType={packageType} />

                {this.props.orderLinesData && this.state.loaded && 
                    <div>
                        <div className="container campaign-menu-container">
                            <CampaignMenu
                                playData={this.props.orderLinesData.playData}
                                postingData={postingData}
                                selectedCampaignType={this.state.selectedCampaignType} />
                        </div>

                        <div className="container">
                            <CampaignInfoPlay
                                selectedData={selectedSummaryData}
                                selectedDataType={selectedSummaryDataType}
                                onSelectDataType={(dataType) => this.handleSelectDataType(dataType)}
                                selectedCampaignType={(dataType) => this.handleSelectDataType(dataType)}
                                campaignInfo={this.props.orderLinesData.orderLineDataInformation}
                                campaignName={this.state.campaignName}
                                periodManuallySelected={this.state.periodManuallySelected}
                                orderData={this.props.orderData}
                                selectedDetailsData={selectedDetailsData}
                                parameters={this.props.parameters}
                                contactsLabel={contactsLabel}
                                panels={selectedData.panels}
                                campaignPackagePromise={this.state.selectedCampaignPromise}
                                useOldPlay={this.state.useOldPlay}
                                selectedOrderLines={this.props.selectedOrderLines}
                                useAlternateContacts={selectedDetailsData.useAlternateContacts} />

                        </div>
                        {showCampaignDays &&
                            <div className="container">
                                {campaignDaysGraph}
                            </div>
                        }
                        <div className="container graphs">
                            <div className="row">

                                <div className="col-md-6">

                                    <Weekdays
                                        showTarget={false}
                                        color1={color1}
                                        color2={color2}
                                        weekdays={selectedData.weekdays}
                                        dataType={selectedDataType} />
                                </div>
                                <div className="col-md-6">
                                    <Regions
                                        showTarget={false}
                                        color1={color1}
                                        color2={color2}
                                        regions={selectedData.regions}
                                        dataType={selectedDataType}
                                        header="Regions"
                                        showPanelExport={true}
                                        campaignType={this.state.selectedCampaignType} />
                                </div>
                            </div>

                            {country !== "dk" &&
                                <div className="row">
                                    <div className="col-md-6">

                                        <EnvironmentPlay
                                            color={color1}
                                            environment={selectedData.environment}
                                            dataType={selectedDataType}
                                            campaignType={this.state.selectedCampaignType} />
                                    </div>
                                    <div className="col-md-6">
                                        <PanelMap
                                            color1={color1}
                                            color2={color2}
                                            panels={selectedData.panels}
                                            campaignType={this.state.selectedCampaignType}
                                            campaignName={this.state.campaignName}
                                            header="Panel locations"
                                            parameters={this.props.parameters}
                                            showPanelExport={true}
                                            allowAddressExport={true} />
                                    </div>
                                </div>
                            }
                            {country === "dk" &&
                                <div className="row">
                                    <div className="col-md-12">
                                        <PanelMap
                                            color1={color1}
                                            color2={color2}
                                            panels={selectedData.panels}
                                            campaignType={this.state.selectedCampaignType}
                                            campaignName={this.state.campaignName}
                                            header="Panel locations"
                                            parameters={this.props.parameters}
                                            showPanelExport={true}
                                            allowAddressExport={true} />
                                    </div>
                                </div>
                            }

                            <div className="row footer-text">
                                {contactsText}
                            </div>
                        </div>
                    </div>
                }
            </div>
        );
    }
}
